export default __webpack_public_path__ + "static/media/wind-day.9d8f65e8.svg";